import styled from 'styled-components';

export const CpHeading01Primary = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-heading-01-primary${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpHeading01Secondary = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-heading-01-secondary${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpHeading01Link = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-heading-01-link${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpHeading01Disabled = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-heading-01-disabled${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpHeading01Placeholder = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-heading-01-placeholder${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpHeading02Primary = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-heading-02-primary${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpHeading02Secondary = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-heading-02-secondary${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpHeading02Link = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-heading-02-link${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpHeading02Disabled = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-heading-02-disabled${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpHeading02Placeholder = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-heading-02-placeholder${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpHeading03Primary = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-heading-03-primary${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpHeading03Secondary = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-heading-03-secondary${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpHeading03Link = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-heading-03-link${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpHeading03Disabled = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-heading-03-disabled${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpHeading03Placeholder = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-heading-03-placeholder${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpHeading04Primary = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-heading-04-primary${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpHeading04Secondary = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-heading-04-secondary${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpHeading04Link = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-heading-04-link${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpHeading04Disabled = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-heading-04-disabled${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpHeading04Placeholder = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-heading-04-placeholder${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpHeading05Primary = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-heading-05-primary${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpHeading05Secondary = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-heading-05-secondary ${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpHeading05Link = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-heading-05-link${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpHeading05Disabled = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-heading-05-disabled${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpHeading05Placeholder = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-heading-05-placeholder${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpHeading06Primary = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-heading-06-primary${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpHeading06Secondary = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-heading-06-secondary${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpHeading06Link = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-heading-06-link${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpHeading06Disabled = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-heading-06-disabled${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpHeading06Placeholder = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-heading-06-placeholder${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

// body styled

export const CpBody01Primary = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-body-01-primary${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpBody01Secondary = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-body-01-secondary${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpBody01Link = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-body-01-link${props.className ? ` ${props.className}` : ''} ${
    props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''
  }`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpBody01Disabled = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-body-01-disabled${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpBody01Placeholder = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-body-01-placeholder${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpBody02Primary = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-body-02-primary${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpBody02Secondary = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-body-02-secondary${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpBody02Link = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-body-02-link${props.className ? ` ${props.className}` : ''} ${
    props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''
  }`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpBody02Disabled = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-body-02-disabled${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpBody02Placeholder = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-body-02-placeholder${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpBody03Primary = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-body-03-primary${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpBody03Secondary = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-body-03-secondary${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpBody03Link = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-body-03-link${props.className ? ` ${props.className}` : ''} ${
    props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''
  }`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpBody03Disabled = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-body-03-disabled${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpBody03Placeholder = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-body-03-placeholder${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpBody00Primary = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-body-00-primary${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpBody00Secondary = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-body-00-secondary${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpBody00Link = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-body-00-link${props.className ? ` ${props.className}` : ''} ${
    props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''
  }`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpBody00Disabled = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-body-00-disabled${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpBody00Placeholder = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-body-00-placeholder ${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

// body-0a
export const CpBody0aPrimary = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-body-0a-primary${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpBody0aSecondary = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-body-0a-secondary${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpBody0aLink = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-body-0a-link${props.className ? ` ${props.className}` : ''} ${
    props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''
  }`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpBody0aDisabled = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-body-0a-disabled${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;

export const CpBody0aPlaceholder = styled.p.attrs<{
  className?: string;
  autoAdjustColor?: boolean;
}>((props) => ({
  className: `cp-body-0a-placeholder ${
    props.className ? ` ${props.className}` : ''
  } ${props?.autoAdjustColor ? 'cp-auto-adjust-color' : ''}`,
}))<{
  autoAdjustColor?: boolean;
}>``;
